export const USER_CHANGE_ROLE = 'USER_CHANGE_ROLE';
export const USER_FETCH = 'USER_FETCH';
export const USER_MANDATE_FETCH = 'USER_MANDATE_FETCH';
export const USER_MANDATES_FETCH = 'USER_MANDATES_FETCH';
export const USER_MANDATE_SELECT = 'USER_MANDATE_SELECT';
export const USER_LOGOUT = 'USER_LOGOUT';
